import { render, staticRenderFns } from "./NextSlides.vue?vue&type=template&id=bf42a9a2&"
import script from "./NextSlides.vue?vue&type=script&lang=js&"
export * from "./NextSlides.vue?vue&type=script&lang=js&"
import style0 from "./NextSlides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports